import { Card, CircularProgress, styled } from "@mui/material";
import React from "react";

const Loading: React.FunctionComponent = () => (
    <Wrapper>
        <Card style={{ padding: 20 }}>
            <CircularProgress />
        </Card>
    </Wrapper>
);

export default Loading;

export const Wrapper = styled("div")`
    position: absolute;
    left: calc(50% - 40px);
    z-index: 2;
    top: calc(50% - 40px);
`;
